module.exports = __WEBPACK_EXTERNAL_MODULE_97__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"jquery","commonjs2":"jquery","amd":"jquery","root":"jQuery"}
// module id = 97
// module chunks = 0